import React, { useRef, useState,useEffect } from "react";
import styles from "./ForgotPassword.module.css";
import Logo from "../../Assets/Images/readPro_logo.png";
import Logo2 from "../../Assets/Images/ify_logo.png";
// import LogoNew from "../../Assets/Images/ify_logo_new.png";
import LogoNew from "../../Assets/Images/IFY_Magicbricks_Logo.png";
import TextInput from "../../Components/TextInput/TextInput";
import { MdEmail } from "react-icons/md";
import background from "../../Assets/Images/passwordBackground.svg";
import { auth } from "../../Firebase";
import { emailValidate } from "../../Values/validatorsnew";
import { useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import Loading from "../../Components/Loading/Loading";
import landingBackground from "../../Assets/Images/landing_background.svg";
import NewBackground from "../../Assets/Images/new_background.jpg";
import LatestBackground from "../../Assets/Images/signin_background_latest.svg";
import AppStore from "../../Assets/Images/appstore.svg";
import LogoOld from "../../Assets/Images/head.svg";
import PlayStore from "../../Assets/Images/playstore.svg";
import { firestore } from "../../Firebase";
import { url } from "../../Values/constants";
// import { forgetPassword } from "../../Services/auth";
import axios from "axios"
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics } from "../../Services/users";
import { createCaptcha, createCaptchaV2 } from "../../Services/auth";
import RefreshCaptchIMg from "../../Assets/Images/refresh_captcha_image.svg"

const ForgotPassword = (props: any) => {

  const emailRef: any = useRef();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [captchaImageUrl, setCaptchaImageUrl] = useState<string>(""); 
  const[answer,setAnswer]=useState<string>("");
  const [captchaInput, setCaptchaInput] = useState<string>("");

    const genereteCaptcha = ()=> {
      createCaptchaV2(
        (value)=>{setCaptchaImageUrl(value)},
        (value)=>{setAnswer(value)},
        dispatcher
      );
    }

      const handleCaptchaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        // Allow numbers between 1 and 9, and the '-' symbol
        if (/^-?[0-9]*$/.test(value)) {
            setCaptchaInput(value);  // Update state with valid input
        }
    };
  // const [authToken,setAuthToken]=useState("");

  // useEffect(() => {
  //   forgetPassword((val: any) => setAuthToken(val));
  // }, []);

  // useEffect(()=>{
  //   console.log("ssdscasdc",authToken)
  // },[])

  useEffect(()=>{
    googleAnalytics('Password_Reset_Screen')
    genereteCaptcha()
  },[])

  const send = async (email: string) => {
    if(captchaInput.length===0){
      dispatcher(
          showSnackbarAction(
            'please enter captcha',
            'error'
          )
        );
      return;
  }

    if (email !== "") {
      try {
        if (email) {
          // setLoad(true);
          // await auth.sendPasswordResetEmail(email);
          // axios.defaults.headers.common['x-access-token'] = authToken
          const res = await axiosHandler.post(url + '/forgetPassword/v3', {
            email:email,
            captchaAnswer:answer,
            captchaInput:captchaInput
          });

          // setLoad(false);
          dispatcher(
            showSnackbarAction(
              res.data.message || "Password reset information have been sent on you registered email id","success"
            )
          );
          genereteCaptcha()
          // props.history.push("/");
        }
      } catch (error:any) {
        // setLoad(false);
        genereteCaptcha()
        dispatcher(
          showSnackbarAction(
            error.response.data.message || "Password reset information have been sent on you registered email id",
            "success"
          )
        )
        props.history.push("/");
      }
    } else {
      dispatcher(showSnackbarAction("Please Enter Your Email!", "error"));
    }
  };
  return (
    <div
      className={styles.container}
    >
      <img src={LogoNew} alt="logo" className={styles.logo} />
      <div style={{ display: "flex", height: "80vh" }}>
        <div className={styles.box1}>
          <img
            src={LatestBackground}
            alt=""
            width="100%"
            height="100%"
          // className={styles.logo}
          />
        </div>
        <div className={styles.box2}>
          <div className={styles.form}>
            <div className={styles.header}>
              <h4 style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "24px" }}>Forgot Password?</h4>
              <p className={styles.headerText} style={{ fontSize: "14px", marginTop: "20px" }}>
                Enter your registered email below to receive password reset
                instructions
              </p>
            </div>
            <div className={styles.inputs}>
              <TextInput title={"Email"} ref={emailRef} validator={emailValidate}>
                <MdEmail color={"#053535"} />
              </TextInput>
            </div>
            <div className={styles.captcha}>
                <img src={captchaImageUrl} className={styles.captchaImg} alt="Captch" />
                <div className={styles.captchaRefresh} onClick={genereteCaptcha}>
                  <div><img src={RefreshCaptchIMg} alt="refresh" /></div>
                  Refresh
                </div>
                
                <div>
                  <input
                    className={styles.captchaInput}
                    type="text"
                    placeholder="Enter CAPTCHA"
                    value={captchaInput}
                    onChange={handleCaptchaChange}
                    style={{textAlign:"center",fontSize:"30"}}
                  />
                </div>
              </div>
            <div className={styles.buttons}>
              <button
                className={styles.button}
                onClick={() => send(emailRef.current?.value)}
              >
                Send
              </button>
              <div
                className={styles.forgetBox}
                // onClick={() => props.history.push("/signInEmail")}
                onClick={() => props.history.push("/")}
              >
                <p style={{ marginBottom: "20px", marginTop: "10px", fontSize: "14px" }}>Remember Password?</p>
                <p className={styles.loginText} style={{ marginBottom: "20px", marginTop: "10px", fontSize: "14px" }}>Login</p>
              </div>
            </div>
            <div className={styles.storeIcons}>
              <div className={styles.iconContainer1}>
                <a href="https://play.google.com/store/apps/details?id=com.readpro" target="_blank">
                  <img
                    src={PlayStore}
                    alt={"logo"}
                    width={"25px"}
                  />
                </a>
              </div>
              <div className={styles.iconContainer2}>
                <a href="https://apps.apple.com/in/app/read-pro/id1566457452" target="_blank">
                  <img
                    src={AppStore}
                    alt={"logo"}
                    width={"40px"}
                  />
                </a>
              </div>
            </div>

            {/* <p style={{ textAlign: "center", marginTop: "24px", fontSize: "14px" }}>Powered by</p>
            <div className={styles.socialIcons}>
              <img
                src={Logo2}
                alt={"logo"}
                height={"35px"}
              />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
